import { withStyles } from '@material-ui/core';
import React from 'react';
import DataGrid from '@dataGrid';
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from '../../components/GridHeader';
import GridConfig from './gridConfig';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../appConfigContext';
import styles from '../../common/GridStyles';
import GridTabHeader from '../../components/GridTabHeader';
import { getExportFilename } from '../../utils';
import { SHIPMENT_SELECTION_STEPS } from '../../constants';

class PreviousDayReturnsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: ''
    };
    this.gridConfig = new GridConfig({
      userConfig: this.props.userProfile?.columnPref,
      columnConfig: this.props.configJSON?.gridColumnConfig,
      terminal: this.props.userProfile?.terminal.code
    });
    this.gridApi = {};
  }

  componentDidMount() {
    this.props.glEventHub.on('previousDayReturnsGrid', this.onSearchTextChanged);
  }

  componentWillUnmount() {
    this.props.glEventHub.off('previousDayReturnsGrid', this.onSearchTextChanged);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.props.onPreviousDayReturnsGridReady(api);
  }

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText
    });
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + ' Returns',
        filterCondition: ''
      }
    ];
  };

  isRowSelectable = (params) => {
    return !params.data.isInPlan;
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, glEventHub, tabList, ...rest } = this.props;
    const exportFileName = getExportFilename({
      tabId: this.props.tabId,
      sectionTitle: 'Returns',
      tabList
    });
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridTabHeader  
          tabList={tabList}
          handleTabChange={this.props.onTabChange}
          tabId={this.props.tabId}
          gridName="Return"
          headerId={SHIPMENT_SELECTION_STEPS.RETURNS}
          handleRefresh={this.props.handleRefresh}
        />
        <GridHeader
          title="Returns"
          headerId="previousDayReturnsGrid"
          glEventHub={glEventHub}
          gridApi={this.gridApi}
          userProfile={this.props.userProfile}
          exportFileName={exportFileName}
          // toggleProps={{
          //   label: 'Show all returns',
          //   value: showPastReturns,
          //   onClick: handleShowPastReturnsClick
          // }}
        />
        <DataGrid
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          onGridReady={this.onGridReady}
          deltaRowDataMode={true}
          quickFilterText={this.state.searchText}
          onCellMouseDown={this.props.onCellMouseDown}
          suppressRowClickSelection
          panelLabel={(filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} />}
          context={this.props.gridContext}
          rowClassRules={config.rowClassRules}
          isRowSelectable={this.isRowSelectable}
          getRowId={(params) => params.data.proId}
          {...rest}
        />
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(PreviousDayReturnsGrid);
